import Image from "next/image";
import { useState } from "react";
import arrowRight from "../../../../public/images/icons/angle-right.png";
import arrowDown from "../../../../public/images/icons/angle-down-black.png";
import styles from "../../../styles/races/national/TaleOfTheTape.module.scss";

const TaleOfTheTapeSelectItem = ({
  index,
  candidates,
  selectedCandidates,
  selectCandidate,
}) => {
  const [isActive, setIsActive] = useState(false);

  const loader = ({ src, width, quality }) => {
    const imageUrl = process.env.SITE_URL;
    return `${imageUrl}${src}?w=${width}&q=${quality || 75}`;
  };

  const toggleActiveSelection = () => {
    setIsActive(!isActive);
  };

  const onCandidateSelect = (candidate) => {
    setIsActive(!isActive);
    selectCandidate(index, candidate);
  };

  const candidateName = (candidate) => {
    return `${candidate.last_name}, ${
      candidate.alternate_name ? candidate.alternate_name : candidate.first_name
    } (${candidate.political_party})`;
  };

  return (
    <div>
      <div className={styles.candidateInfoListItemAccordion}>
        <div
          className={styles.candidateInfoItemHeader}
          onClick={() => toggleActiveSelection()}
        >
          {selectedCandidates[index].id === undefined ? (
            <p>
              SELECT {index === 0 ? "FIRST" : index === 1 ? "SECOND" : "THIRD"}{" "}
              CANDIDATE
            </p>
          ) : (
            <div className={styles.candidateInfoItem}>
              <Image
                src={selectedCandidates[index].thumbnail}
                alt={candidateName(selectedCandidates[index])}
                width={60}
                height={60}
              />
              <div className={styles.candidateInfoItemTitle}>
                <div className={styles.candidateInfoItemLastName}>
                  <span>{selectedCandidates[index].ballot_no}</span>{" "}
                  {selectedCandidates[index].last_name}
                </div>
                <div className={styles.candidateInfoItemFirstName}>
                  {selectedCandidates[index].alternate_name
                    ? selectedCandidates[index].alternate_name
                    : selectedCandidates[index].first_name}{" "}
                  ({selectedCandidates[index].political_party})
                </div>
              </div>
            </div>
          )}
          <div className={styles.arrow}>
            {isActive ? (
              <Image
                loader={loader}
                src={arrowDown}
                alt="arrow down"
                width={12}
                height={8}
              />
            ) : (
              <Image
                loader={loader}
                src={arrowRight}
                alt="arrow right"
                width={8}
                height={12}
              />
            )}
          </div>
        </div>
      </div>
      {isActive && (
        <div className={styles.candidateInfoItemBody}>
          {candidates.map((candidate) => {
            if (
              !selectedCandidates
                .map((candidate) => candidate.id)
                .includes(candidate.id)
            ) {
              return (
                <div
                  key={candidate.id}
                  className={styles.candidateInfoItemBodyContent}
                  onClick={() => onCandidateSelect(candidate)}
                >
                  <span>{candidateName(candidate)}</span>
                </div>
              );
            }
          })}
        </div>
      )}
    </div>
  );
};

export default TaleOfTheTapeSelectItem;
